import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { AuthUser } from '../../../services/AuthService';

interface SidebarSection {
  id: string;
  name: string;
  icon: string;
  path: string;
  badge?: {
    text: string;
    color: string;
  };
}

interface SettingsSidebarProps {
  user: AuthUser;
}

const SettingsSidebar: React.FC<SettingsSidebarProps> = ({ user }) => {
  const location = useLocation();

  const sections: SidebarSection[] = [
    { id: 'profile', name: 'Profile', icon: '👤', path: '/settings/profile' },
    { id: 'security', name: 'Security', icon: '🔒', path: '/settings/security' },
    { id: 'preferences', name: 'Preferences', icon: '⚙️', path: '/settings/preferences' }
  ];

  const isActiveSection = (path: string) => location.pathname === path;

  return (
    <aside className="py-6 px-2 sm:px-6 lg:py-0 lg:px-0 lg:col-span-3">
      <nav className="space-y-1">
        {sections.map((section) => (
          <Link
            key={section.id}
            to={section.path}
            className={`${
              isActiveSection(section.path)
                ? 'bg-blue-50 border-blue-500 text-blue-700 hover:bg-blue-50 hover:text-blue-700'
                : 'border-transparent text-gray-900 hover:bg-gray-50 hover:text-gray-900'
            } group border-l-4 px-3 py-2 flex items-center text-sm font-medium w-full text-left transition-colors`}
          >
            <span className="mr-3 text-lg">{section.icon}</span>
            {section.name}
            {section.badge && (
              <span className={`ml-auto bg-${section.badge.color}-100 text-${section.badge.color}-600 px-2 py-1 text-xs rounded-full`}>
                {section.badge.text}
              </span>
            )}
          </Link>
        ))}
      </nav>
    </aside>
  );
};

export default SettingsSidebar; 